import { Controller } from "@hotwired/stimulus"

// Client-side search filter for the Users table.
// Filters rows by matching name/email against the search input.
export default class extends Controller {
  static targets = ["input", "row", "count", "emptyState", "tableBody", "addUserForm", "addButton"]

  filter() {
    const query = this.inputTarget.value.toLowerCase()
    let visible = 0

    this.rowTargets.forEach(row => {
      const text = row.dataset.searchText || ""
      const match = text.includes(query)
      row.style.display = match ? "" : "none"
      if (match) visible++
    })

    this.countTarget.textContent = visible

    if (this.hasEmptyStateTarget) {
      this.emptyStateTarget.classList.toggle("hidden", visible > 0)
    }

    // Hide the table wrapper border when no results
    const tableWrapper = this.tableBodyTarget.closest(".table-border-wrapper")
    if (tableWrapper) {
      tableWrapper.classList.toggle("hidden", visible === 0 && query.length > 0)
    }
  }

  toggleAddUser() {
    const form = this.addUserFormTarget
    const isHidden = form.classList.contains("hidden")
    form.classList.toggle("hidden")

    if (isHidden) {
      // Focus the first input
      const firstInput = form.querySelector("input[type=text]")
      if (firstInput) firstInput.focus()
    }
  }
}
